<template>
  <div class="mini-preloader" style="height: 45px">
    <img src="../../assets/images/categoryLoader.gif" width="45" alt />
  </div>
</template>

<script>
export default {};
</script>
